import React, { useEffect, useState } from "react";
import Header from "../header/Header";
import SideBar from "../sidebar/SideBar";
import Table from "../Table";
import ClientHeader from "./ClientHeader";
import { PiDotsThreeVerticalBold } from "react-icons/pi";
import { Dropdown, Menu, Modal, Space } from "antd";
import DashboardLayout from "../layout";

const obj = {
  ative: true,
  content: "Clients",
};

const Index = () => {
  // show edit,del on click
  const [menuVisible, setMenuVisible] = useState(false);
  // show delete modal state
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);

  // for edit and delete functionality
  const handleMenuClick = ({ key }) => {
    if (key === "edit") {
      // Handle the edit action
    } else if (key === "delete") {
      // Handle the delete action
      setShowDeleteConfirmationModal(true);
    }
    setMenuVisible(false); // Close the menu after the click
  };
  // close action buttons if click anywhere outside
  useEffect(() => {
    const closeMenuOnOutsideClick = (event) => {
      if (menuVisible) {
        const dropdownContainer = document.querySelector(".ant-dropdown");
        if (dropdownContainer && !dropdownContainer.contains(event.target)) {
          setMenuVisible(false); // Close the menu if the click is outside the dropdown
        }
      }
    };

    document.body.addEventListener("click", closeMenuOnOutsideClick);

    return () => {
      document.body.removeEventListener("click", closeMenuOnOutsideClick);
    };
  }, [menuVisible]);
  return (
    <>
      <DashboardLayout>
        {/* <div className="h-full sm:block hidden border-r  ">
          <SideBar obj={obj} />
        </div> */}
        <div className="w-full">
          <Header title="Clients" />

          <div className="p-5 bg-[#eaeff6]">
            <ClientHeader />
            {/* <Table checkbox={true} headings={['Client Name','Gender','Email','Phone Number','Country','Address','Actions']}/> */}
            <div className="bg-white rounded-md md:py-5 py-3 px-0 flex items-center mt-4 justify-between">
              {/* for web */}
              <div className="hidden sm:inline  w-full">
                <table className="w-full text-sm text-center ">
                  <thead className=" font-normal">
                    <tr className="border-b-2 text-[#000000A3] ">
                      <th className="p-1">#</th>
                      <th className="p-1">Client Name</th>
                      <th className="p-1">Gender</th>
                      <th className="p-1">Email</th>
                      <th className="p-1">Phone Number</th>
                      <th className="p-1">Country</th>
                      <th className="p-1">Address</th>
                      <th className="p-1">Action</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    <tr className="border-b-2 ">
                      <td className="p-1">1</td>
                      <td className="p-1">John Doe</td>

                      <td className="p-1">Male</td>
                      <td className="p-1">User78@email.com</td>
                      <td className="p-1">+91 3455666 77</td>
                      <td className="p-1">USA</td>
                      <td className="p-1">Street 23, Apartment 2</td>
                      <td className="p-1">
                        <Dropdown
                          overlay={
                            <Menu onClick={handleMenuClick}>
                              <Menu.Item key="edit">
                                <Space>Edit</Space>
                              </Menu.Item>
                              <Menu.Item key="delete">
                                <Space>Delete</Space>
                              </Menu.Item>
                            </Menu>
                          }
                          visible={menuVisible}
                          trigger={["click"]}
                        >
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation(); // Stop the click event from propagating to the body
                              setMenuVisible(true); // Open the menu on click
                            }}
                          >
                            <Space>
                              <button className="border p-1 rounded-md border-[#053F92]">
                                <PiDotsThreeVerticalBold size={20} />
                              </button>
                            </Space>
                          </a>
                        </Dropdown>
                      </td>
                    </tr>
                    <tr className="border-b-2 ">
                      <td className="p-1">1</td>
                      <td className="p-1">John Doe</td>

                      <td className="p-1">Male</td>
                      <td className="p-1">User78@email.com</td>
                      <td className="p-1">+91 3455666 77</td>
                      <td className="p-1">USA</td>
                      <td className="p-1">Street 23, Apartment 2</td>
                      <td className="p-1">
                        <button className="border p-1 rounded-md border-[#053F92]">
                          <PiDotsThreeVerticalBold size={20} />
                        </button>
                      </td>
                    </tr>
                    <tr className="border-b-2 ">
                      <td className="p-1">1</td>
                      <td className="p-1">John Doe</td>

                      <td className="p-1">Male</td>
                      <td className="p-1">User78@email.com</td>
                      <td className="p-1">+91 3455666 77</td>
                      <td className="p-1">USA</td>
                      <td className="p-1">Street 23, Apartment 2</td>
                      <td className="p-1">
                        <button className="border p-1 rounded-md border-[#053F92]">
                          <PiDotsThreeVerticalBold size={20} />
                        </button>
                      </td>
                    </tr>
                    <tr className="border-b-2 ">
                      <td className="p-1">1</td>
                      <td className="p-1">John Doe</td>

                      <td className="p-1">Male</td>
                      <td className="p-1">User78@email.com</td>
                      <td className="p-1">+91 3455666 77</td>
                      <td className="p-1">USA</td>
                      <td className="p-1">Street 23, Apartment 2</td>
                      <td className="p-1">
                        <button className="border p-1 rounded-md border-[#053F92]">
                          <PiDotsThreeVerticalBold size={20} />
                        </button>
                      </td>
                    </tr>
                    <tr className="border-b-2 ">
                      <td className="p-1">1</td>
                      <td className="p-1">John Doe</td>

                      <td className="p-1">Male</td>
                      <td className="p-1">User78@email.com</td>
                      <td className="p-1">+91 3455666 77</td>
                      <td className="p-1">USA</td>
                      <td className="p-1">Street 23, Apartment 2</td>
                      <td className="p-1">
                        <button className="border p-1 rounded-md border-[#053F92]">
                          <PiDotsThreeVerticalBold size={20} />
                        </button>
                      </td>
                    </tr>
                    <tr className="border-b-2 ">
                      <td className="p-1">1</td>
                      <td className="p-1">John Doe</td>

                      <td className="p-1">Male</td>
                      <td className="p-1">User78@email.com</td>
                      <td className="p-1">+91 3455666 77</td>
                      <td className="p-1">USA</td>
                      <td className="p-1">Street 23, Apartment 2</td>
                      <td className="p-1">
                        <button className="border p-1 rounded-md border-[#053F92]">
                          <PiDotsThreeVerticalBold size={20} />
                        </button>
                      </td>
                    </tr>
                    <tr className="border-b-2 ">
                      <td className="p-1">1</td>
                      <td className="p-1">John Doe</td>

                      <td className="p-1">Male</td>
                      <td className="p-1">User78@email.com</td>
                      <td className="p-1">+91 3455666 77</td>
                      <td className="p-1">USA</td>
                      <td className="p-1">Street 23, Apartment 2</td>
                      <td className="p-1">
                        <button className="border p-1 rounded-md border-[#053F92]">
                          <PiDotsThreeVerticalBold size={20} />
                        </button>
                      </td>
                    </tr>
                    <tr className="border-b-2 ">
                      <td className="p-1">1</td>
                      <td className="p-1">John Doe</td>

                      <td className="p-1">Male</td>
                      <td className="p-1">User78@email.com</td>
                      <td className="p-1">+91 3455666 77</td>
                      <td className="p-1">USA</td>
                      <td className="p-1">Street 23, Apartment 2</td>
                      <td className="p-1">
                        <button className="border p-1 rounded-md border-[#053F92]">
                          <PiDotsThreeVerticalBold size={20} />
                        </button>
                      </td>
                    </tr>
                    <tr className="border-b-2 ">
                      <td className="p-1">1</td>
                      <td className="p-1">John Doe</td>

                      <td className="p-1">Male</td>
                      <td className="p-1">User78@email.com</td>
                      <td className="p-1">+91 3455666 77</td>
                      <td className="p-1">USA</td>
                      <td className="p-1">Street 23, Apartment 2</td>
                      <td className="p-1">
                        <button className="border p-1 rounded-md border-[#053F92]">
                          <PiDotsThreeVerticalBold size={20} />
                        </button>
                      </td>
                    </tr>
                    <tr className="border-b-2 ">
                      <td className="p-1">1</td>
                      <td className="p-1">John Doe</td>

                      <td className="p-1">Male</td>
                      <td className="p-1">User78@email.com</td>
                      <td className="p-1">+91 3455666 77</td>
                      <td className="p-1">USA</td>
                      <td className="p-1">Street 23, Apartment 2</td>
                      <td className="p-1">
                        <button className="border p-1 rounded-md border-[#053F92]">
                          <PiDotsThreeVerticalBold size={20} />
                        </button>
                      </td>
                    </tr>
                    <tr className="border-b-2 ">
                      <td className="p-1">1</td>
                      <td className="p-1">John Doe</td>

                      <td className="p-1">Male</td>
                      <td className="p-1">User78@email.com</td>
                      <td className="p-1">+91 3455666 77</td>
                      <td className="p-1">USA</td>
                      <td className="p-1">Street 23, Apartment 2</td>
                      <td className="p-1">
                        <button className="border p-1 rounded-md border-[#053F92]">
                          <PiDotsThreeVerticalBold size={20} />
                        </button>
                      </td>
                    </tr>
                    <tr className="border-b-2 ">
                      <td className="p-1">1</td>
                      <td className="p-1">John Doe</td>

                      <td className="p-1">Male</td>
                      <td className="p-1">User78@email.com</td>
                      <td className="p-1">+91 3455666 77</td>
                      <td className="p-1">USA</td>
                      <td className="p-1">Street 23, Apartment 2</td>
                      <td className="p-1">
                        <button className="border p-1 rounded-md border-[#053F92]">
                          <PiDotsThreeVerticalBold size={20} />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* for mobile */}
              <div className=" p-4 sm:hidden  w-full">
                {/* 1st card */}
                <div className=" flex wrap    justify-between items-center  mt-3 w-full  pb-3">
                  <div className="flex-wrap">
                    <p className="font-semibold text-lg">#</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      1
                    </p>
                  </div>
                  <div className="flex-wrap text-end">
                    <p className="font-semibold text-lg">Client Name</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      John
                    </p>
                  </div>
                </div>
                <div className=" flex wrap   justify-between items-center pb-3  w-full  ">
                  <div className="flex-wrap">
                    <p className="font-semibold text-lg">Gender</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      Male
                    </p>
                  </div>
                  <div className="text-end flex-wrap">
                    <p className="font-semibold text-lg">Email</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      User78@email.com
                    </p>
                  </div>
                </div>
                <div className=" flex wrap   justify-between items-center pb-3  w-full  ">
                  <div className="flex-wrap">
                    <p className="font-semibold text-lg">Phone Number</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      +91 3455666 77
                    </p>
                  </div>
                  <div className="text-end flex-wrap">
                    <p className="font-semibold text-lg">Country</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      USA
                    </p>
                  </div>
                </div>
                <div className=" flex wrap   justify-between items-center pb-3  w-full  ">
                  <div className="flex-wrap">
                    <p className="font-semibold text-lg">Address</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      Street 23, Apartment 2
                    </p>
                  </div>
                </div>
                {/* Actions */}
                <div className="flex justify-between  border-b border-[#A51F6C] pb-5">
                  <div
                    onClick={() => setShowDeleteConfirmationModal(true)}
                    className="flex-wrap"
                  >
                    <button
                      className="border  border-cus-red rounded-md p-1 
                                                text-cus-red bg-[#fae4e1] w-28"
                    >
                      Delete
                    </button>
                  </div>
                  <div className="flex-wrap">
                    <button
                      className="border border-cus-green rounded-md p-1 ms-2
                                                 text-cus-green bg-[#e2f8d5] w-28"
                    >
                      Edit
                    </button>
                  </div>
                </div>

                {/* 2ndcard */}
                <div className=" flex wrap    justify-between items-center  mt-3 w-full  pb-3">
                  <div className="flex-wrap">
                    <p className="font-semibold text-lg">#</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      1
                    </p>
                  </div>
                  <div className="flex-wrap text-end">
                    <p className="font-semibold text-lg">Client Name</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      John
                    </p>
                  </div>
                </div>
                <div className=" flex wrap   justify-between items-center pb-3  w-full  ">
                  <div className="flex-wrap">
                    <p className="font-semibold text-lg">Gender</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      Male
                    </p>
                  </div>
                  <div className="text-end flex-wrap">
                    <p className="font-semibold text-lg">Email</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      User78@email.com
                    </p>
                  </div>
                </div>
                <div className=" flex wrap   justify-between items-center pb-3  w-full  ">
                  <div className="flex-wrap">
                    <p className="font-semibold text-lg">Phone Number</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      +91 3455666 77
                    </p>
                  </div>
                  <div className="text-end flex-wrap">
                    <p className="font-semibold text-lg">Country</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      USA
                    </p>
                  </div>
                </div>
                <div className=" flex wrap   justify-between items-center pb-3  w-full  ">
                  <div className="flex-wrap">
                    <p className="font-semibold text-lg">Address</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      Street 23, Apartment 2
                    </p>
                  </div>
                </div>
                {/* Actions */}
                <div className="flex justify-between  border-b border-[#A51F6C] pb-5">
                  <div className="flex-wrap">
                    <button
                      className="border  border-cus-red rounded-md p-1 
                                                text-cus-red bg-[#fae4e1] w-28"
                    >
                      Delete
                    </button>
                  </div>
                  <div className="flex-wrap">
                    <button
                      className="border border-cus-green rounded-md p-1 ms-2
                                                 text-cus-green bg-[#e2f8d5] w-28"
                    >
                      Edit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DashboardLayout>
      {/* modal for delete from antd */}
      <Modal
        title="Confirm Deletion"
        open={showDeleteConfirmationModal}
        onCancel={() => setShowDeleteConfirmationModal(false)}
        // onOk={() => {
        // console.log("DELETE", selectedProduct);
        // deleteMutation.mutate(selectedProductId) }}
        okText="Yes"
        cancelText="No"
        okButtonProps={{
          style: { backgroundColor: "#D83535", color: "#FFFFFF" },
        }}
      >
        <p>Are you sure you want to delete the selected shipment?</p>
      </Modal>
    </>
  );
};

export default Index;
